import type { ComponentProps } from 'react';
import { FieldInfo, hasFieldError, useFieldContext, useIsFieldOptional } from './shared';
import { FieldLabelRow } from './field-label-row';
import { Input } from '../input';

export default function ColorField({ label, className, ...props }: ComponentProps<'input'> & { label: string }) {
	const field = useFieldContext<string>();
	const isOptional = useIsFieldOptional(field.name);

	return (
		<div className={className}>
			<div className="grid gap-2">
				{label && (
					<FieldLabelRow
						label={label}
						htmlFor={field.name}
						hasError={field.state.meta.isTouched && !field.state.meta.isValid}
						optional={isOptional}
					/>
				)}
				<div className="relative">
					<input
						type="color"
						value={field.state.value ?? ''}
						onBlur={field.handleBlur}
						onChange={(e) => field.handleChange(e.target.value)}
						className="border-input absolute top-1/2 left-3 size-4 -translate-y-1/2 cursor-pointer rounded-full border"
					/>
					<Input
						type="text"
						id={field.name}
						name={field.name}
						aria-invalid={hasFieldError(field.state.meta)}
						value={field.state.value ?? ''}
						onBlur={field.handleBlur}
						onChange={(e) => field.handleChange(e.target.value)}
						className="pl-8"
						{...props}
					/>
				</div>
			</div>
			<FieldInfo fieldState={field.state} />
		</div>
	);
}
